import apiHandler from '../../utilities/apiHandler.js';


const JobsOperationsApiHandler = {

    getPendingJobsForProcessType: function (processType) {
        var URL = "jobs/creation/pending?processType=" + processType;
        return apiHandler.get(URL);
    },

    getFcUsersForProcessType: function (processType, showAllUsers) {
        if (showAllUsers !== true && showAllUsers !== false) {
            //in case of undefined or null or other random value
            showAllUsers = false;
        }

        var URL = "bradman/get-fc-users-for-fcuserrole?fcuserrole=" + processType + "&fetchForBranch=" + !showAllUsers;
        return apiHandler.get(URL);
    },

    getJobsForDashboardShow: function (processType) {
        var URL = "jobs/pending/all/product-wise?processType=" + processType;
        return apiHandler.get(URL);
    },

    getJobsForJpinAndProcessType: function (jpin, processType) {
        var URL = "jobs/pending/job/steps/product/" + jpin + "?processType=" + processType;
        return apiHandler.get(URL);
    },

    // getSlotProcessingStatus: function(time, processPhase) {
    //     var URL = "jobs/pick-jobs/progress?deliveryDate=" + time + "&processPhase=" + processPhase;
    //     return apiHandler.get(URL);
    // },

    getSlotProcessingStatus: function (request) {
        var URL = "jobs/pick-jobs/progress";
        return apiHandler.post(URL, request);
    },

    getJobCreationSTatus: function (id) {
        var URL = "jobs/job-creation-status/" + id;
        return apiHandler.get(URL);
    },

    createPickJob: function (request) {
        var URL = "jobs/imr/create/pick-job";
        return apiHandler.put(URL, request);
    },

    fetchDeliveryDates: function () {
        var URL = "dispatch/delivery-dates";
        return apiHandler.get(URL);
    },

    fetchSortingTypes: function () {
        var URL = "dispatch/sorting/types";
        return apiHandler.get(URL);
    },

    fetchSlotsForDate: function (dateEpoch) {
        var URL = "dispatch/delivery-date/slots/?deliveryDate=" + dateEpoch;
        return apiHandler.get(URL);
    },

    getHubsForSlot: function (req) {
        var URL = "dispatch/delivery-date/slot/hubs";
        return apiHandler.post(URL, req);
    },

    getTripsForHubAndSlot: function (req) {
        var URL = "dispatch/delivery-date/slot/hub/trips";
        return apiHandler.post(URL, req);
    },

    generateDispatchSortingJobs: function (request) {
        var URL = "dispatch/sorting/jobs/generate";
        return apiHandler.post(URL, request);
    },

    generateAssignmentJobs: function (request) {
        var URL = "jobs/job/create";
        return apiHandler.post(URL, request);
    },

    // Splits request.requests across request.userIdsToAssign; one job is created per user.
    generateAndAssignJobsToUsers: function (request) {
        var URL = "jobs/job/create-and-assign";
        return apiHandler.post(URL, request);
    },

    assignUsersAndGeneratePickJob: function (request) {
        var URL = "jobs/pick-job/create-and-assign";
        return apiHandler.post(URL, request);
    },

    reassignPickJobs: function (request) {
        var URL = "jobs/reassign";
        return apiHandler.post(URL, request);
    },

    getPickJobsConfig: function () {
        var URL = "jobs/picking/params";
        return apiHandler.get(URL);
    },

    getSpaceTypeConfig: function (req) {
        var URL = "space/facility/space-type/spaces";
        return apiHandler.post(URL, req);
    },

    refreshSortingReadiness: function (req) {
        var URL = "dispatch/sorting/readiness/refresh";
        return apiHandler.post(URL, req);
    }

}

export default JobsOperationsApiHandler;


// WEBPACK FOOTER //
// ./src/screens/JobOperations/JobsOperationsApiHandler.js